/**
 * Created by guyavarham on 16/05/2017.
 */

import React from 'react';

const divComponent = props => <div>{props.children}</div>;
export default divComponent;
